import React from 'react';
import { Link } from 'react-router-dom';

export const Header: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
      <div className="container px-4 mx-auto">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-4">
            <img src="/img/logo.png" alt="ValutoAuto" className="h-10" />
          </Link>

          <nav className="items-center hidden space-x-8 md:flex">
            <a 
              href="#come-funziona" 
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('come-funziona');
              }}
              className="text-gray-700 transition hover:text-blue-600"
            >
              Come Funziona
            </a>
            <a 
              href="#servizi"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('servizi');
              }}
              className="text-gray-700 transition hover:text-blue-600"
            >
              Servizi
            </a>
            <a 
              href="#marche"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('marche');
              }}
              className="text-gray-700 transition hover:text-blue-600"
            >
              Marche Auto
            </a>
            <a 
              href="#newsletter"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('newsletter');
              }}
              className="text-gray-700 transition hover:text-blue-600"
            >
              Newsletter
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};